import React, { useState } from 'react';
import styled from 'styled-components';
import './style.css'

const videoData = [
  {
    id: 1,
    title: 'How to Login and Overview of the Dashboard',
    src: 'https://lms-videos-thumbnails.s3.me-central-1.amazonaws.com/Navigate+through+LMS/learners-university-college-lms-login-and-dashboard-overview.mp4.mp4',
    thumbnail: 'https://lms-videos-thumbnails.s3.me-central-1.amazonaws.com/Navigate+through+LMS/thumbnail.jpg'
  },
  {
    id: 2,
    title: 'Access FAQs, Book an Support session or connect with an agent',
    src: 'https://lms-videos-thumbnails.s3.me-central-1.amazonaws.com/Navigate+through+LMS/how-to-use-learners-university-college-lms-support-features.mp4.mp4',
    thumbnail: 'https://lms-videos-thumbnails.s3.me-central-1.amazonaws.com/Navigate+through+LMS/thumbnail.jpg'
  },
  {
    id: 3,
    title: 'Join live classes, access completed classes, module kit and assignments',
    src: 'https://lms-videos-thumbnails.s3.me-central-1.amazonaws.com/Navigate+through+LMS/how-to-navigate-learners-university-college-lms.mp4.mp4',
    thumbnail: 'https://lms-videos-thumbnails.s3.me-central-1.amazonaws.com/Navigate+through+LMS/thumbnail.jpg'
  },
  {
    id: 4,
    title: 'Submit an assignment, check for new and evaluated assignments',
    src: 'https://lms-videos-thumbnails.s3.me-central-1.amazonaws.com/Navigate+through+LMS/how-to-manage-assignments-on-lms.mp4',
    thumbnail: 'https://lms-videos-thumbnails.s3.me-central-1.amazonaws.com/Navigate+through+LMS/thumbnail.jpg'
  },
  {
    id: 5,
    title: 'How to Manage Course Fee Payments',
    src: 'https://lms-videos-thumbnails.s3.me-central-1.amazonaws.com/Navigate+through+LMS/how-to-manage-your-course-fee-payments-on-lms.mp4',
    thumbnail: 'https://lms-videos-thumbnails.s3.me-central-1.amazonaws.com/Navigate+through+LMS/thumbnail.jpg'
  }
];

const NavigateLMS = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const openModal = (video) => {
    setSelectedVideo(video);
  };

  const closeModal = () => {
    setSelectedVideo(null);
  };

  return (
    <Container>
      <Title>Navigate through LMS</Title>
      <Description>
        Watch these tutorial videos to learn how to use the LMS effectively
      </Description>
      <VideoGrid>
        {videoData.map((video) => (
          <div className='videoCard' key={video.id} onClick={() => openModal(video)}>
            <div className='thumbnail' style={{backgroundImage:`url(${video.thumbnail})`,backgroundSize:"cover",backgroundRepeat: 'no-repeat'}}>
              <div className='playButton'>▶</div> 
               </div>
            
            <VideoTitle>{video.title}</VideoTitle>
          </div>
        ))}
      </VideoGrid>

      {selectedVideo && (
        <ModalOverlay onClick={closeModal}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <div style={{display:"flex", justifyContent:"end"}}>
            <button onClick={closeModal}><CloseButton >x</CloseButton></button>
            </div>
            
            <video controls autoPlay>
              <source src={selectedVideo.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <ModalTitle>{selectedVideo.title}</ModalTitle>
          </ModalContent>
        </ModalOverlay>
      )}
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  padding: 1rem 0.5rem;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #333;
  margin-bottom: 1rem;
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 2rem;
`;

const VideoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
`;


const VideoTitle = styled.h3`
  padding: 1rem;
  font-size: 1rem;
  color: #333;
  margin: 0;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  position: relative;
  background: #fff;
  border-radius: 10px;
  padding: 1rem;
  max-width: 800px;
  width: 90%;

  video {
    width: 100%;
    border-radius: 10px;
  }
`;

const ModalTitle = styled.h2`
  margin-top: 1rem;
  font-size: 1.2rem;
  text-align: center;
  color: #333;
`;

const CloseButton = styled.button`
  position: relative
  top: 0.5rem;
  right: 1rem;
  background: none;
  font-size: 1.5rem;
  color: #888;
  cursor: pointer;
`;

export default NavigateLMS;
